import React from 'react'

import { withTranslation } from 'react-i18next'

const Error = ({ i18n, t }) => {
  const startURL = i18n.language === 'en' ? process.env.REACT_APP_PAGE_NOT_FOUND_URL : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h1 className="has-error" style={{ display: 'flex', justifyContent: 'center' }}>
            <i
              style={{ marginLeft: '15px', display: 'flex', alignItems: 'center' }}
              className="fa fa-exclamation-circle"
              aria-hidden="true"
            ></i>{' '}
            {t('error_page.error_occured')}
          </h1>
        </div>
      </div>
      <button
        className="btn-lg btn-default"
        style={{ display: 'flex', justifyContent: 'center' }}
        onClick={() => window.location.assign(startURL)}
        name={t('error_page.go_to_start')}
        vale={t('error_page.go_to_start')}
      >
        {t('error_page.go_to_start')}
      </button>
    </div>
  )
}

export default withTranslation('common')(Error)
